// extracted by mini-css-extract-plugin
export var landing = "landing-module--landing--1EhSW";
export var background = "landing-module--background--pVtEq";
export var image2 = "landing-module--image2--1vqyg";
export var text = "landing-module--text--3dYp8";